module.exports = __webpack_public_path__ + "img/mesa-lado-de-fora2.af8c3f40.webp";